import config from "./config.js"
import {generateSigNew} from "./md5util.js";
import md5 from 'js-md5';
const rootPath = config.netBasePath;


export function get({context,basePath = rootPath, url, params = {},onCallBack,onErr}) {
    var API = ""
    if (params == "" || params == null) {
        API = `${basePath}${url}`
    } else {
        var args = []
        var ts = new Date().getTime()
        for (var prop in params) {
            if(params[prop] === ''){
                continue;
            }
            args.push(`${encodeURIComponent(prop)}=${encodeURIComponent(params[prop])}`)
        }
        args.push("scopeType="+context.$store.getters.getScope.scopeType);
        args.push("scope="+`${encodeURIComponent(context.$store.getters.getScope.scope)}`);
        args.push("userId="+context.$store.getters.getUser.userId);
        args.push("accessToken="+context.$store.getters.getUser.accessToken);
        args.push("ts="+ts); //加入时间搓
        let argsSort = args.sort(function(s, t) {
            let a = s.toLowerCase();
            let b = t.toLowerCase();
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
        })
        API= `${basePath}${url}?${argsSort.join('&')}`
        var ssig = generateSigNew(argsSort.join('&'),ts)
        API+='&ssig='+ssig;
    }
    context.$http.get(API).then(function (res) {
        var body = res.body;
        if (body.retCode === 1) {
            onCallBack(body.retMap);
        }else if(body.retCode === 1001){
            if(context.$store.getters.getIsTip){
                window.location.href = context.$store.getters.getCallBack;
            }else{
                context.$router.push('/login');
            }
        }else{
            if('msg' in body && body.msg != undefined){
                context.$Message.error(body.msg);
            }else{
                onErr(body)
            }
        }
    }, function () {
        context.$Message.error('Network request error!');
    }).catch(function (e) {
        console.log(e);
    })
}


export function getScopeArgs({context,basePath = rootPath, url, params = {}}) {
    var API = ""
    if (params == "" || params == null) {
        API = `${basePath}${url}`
    } else {
        var args = []
        var ts = new Date().getTime()
        for (var prop in params) {
            if(params[prop] === ''){
                continue;
            }
            args.push(`${encodeURIComponent(prop)}=${encodeURIComponent(params[prop])}`)
        }
        args.push("scopeType="+context.$store.getters.getScope.scopeType);
        args.push("scope="+`${encodeURIComponent(context.$store.getters.getScope.scope)}`);
        args.push("userId="+context.$store.getters.getUser.userId);
        args.push("accessToken="+context.$store.getters.getUser.accessToken);
        args.push("ts="+ts); //加入时间搓
        let argsSort = args.sort(function(s, t) {
            let a = s.toLowerCase();
            let b = t.toLowerCase();
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
        })
        API= `${basePath}${url}?${argsSort.join('&')}`
        var ssig = generateSigNew(argsSort.join('&'),ts)
        API+='&ssig='+ssig;
    }
   return API;
}





export function getScope({context,basePath = rootPath, url, params = {},onCallBack,onErr}) {
    var API = ""
    if (params == "" || params == null) {
        API = `${basePath}${url}`
    } else {
        var args = []
        var ts = new Date().getTime()
        for (var prop in params) {
            if(params[prop] === ''){
                continue;
            }
            args.push(`${encodeURIComponent(prop)}=${encodeURIComponent(params[prop])}`)
        }
        args.push("accessToken="+context.$store.getters.getUser.accessToken);
        args.push("userId="+context.$store.getters.getUser.userId);
        args.push("ts="+ts); //加入时间搓
        let argsSort = args.sort(function(s, t) {
            let a = s.toLowerCase();
            let b = t.toLowerCase();
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
        })
        API= `${basePath}${url}?${argsSort.join('&')}`
        var ssig = generateSigNew(argsSort.join('&'),ts)
        API+='&ssig='+ssig;
    }
    context.$http.get(API).then(function (res) {
        var body = res.body;
        if (body.retCode === 1) {
            onCallBack(body.retMap);
        }else if(body.retCode === 1001){
            if(context.$store.getters.getIsTip){
                window.location.href = context.$store.getters.getCallBack;
            }else{
                context.$router.push('/login');
            }
        }else{
            if('msg' in body && body.msg != undefined){
                context.$Message.error(body.msg);
            }else{
                onErr(body)
            }
        }
    }, function () {
     /*   context.$Message.error('Network request error!');*/
    }).catch(function (e) {
        console.log(e);
    });
}


export function getSingleData({context,basePath = rootPath, url, params = {},onCallBack,onErr}) {
    var API = ""
    if (params == "" || params == null) {
        API = `${basePath}${url}`
    } else {
        var args = []
        var ts = new Date().getTime()
        for (var prop in params) {
            if(params[prop] === ''){
                continue;
            }
            args.push(`${encodeURIComponent(prop)}=${encodeURIComponent(params[prop])}`)
        }
        args.push("accessToken="+context.$store.getters.getUser.accessToken);
        args.push("userId="+context.$store.getters.getUser.userId);
        args.push("ts="+ts); //加入时间搓
        let argsSort = args.sort(function(s, t) {
            let a = s.toLowerCase();
            let b = t.toLowerCase();
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
        })
        API= `${basePath}${url}?${argsSort.join('&')}`
        var ssig = generateSigNew(argsSort.join('&'),ts)
        API+='&ssig='+ssig;
    }
    context.$http.get(API).then(function (res) {
        var body = res.body;
        if (body.retCode === 1) {
            onCallBack(body.retMap);
        }else if(body.retCode === 1001){
            if(context.$store.getters.getIsTip){
                window.location.href = context.$store.getters.getCallBack;
            }else{
                context.$router.push('/login');
            }
        }else{
            if('msg' in body && body.msg != undefined){
                context.$Message.error(body.msg);
            }else{
                onErr(body)
            }
        }
    }, function () {
        /*   context.$Message.error('Network request error!');*/
    }).catch(function (e) {
        console.log(e);
    });
}


export function getSingleArgs({context,basePath = rootPath, url, params = {}}) {
    var API = ""
    if (params == "" || params == null) {
        API = `${basePath}${url}`
    } else {
        var args = []
        var ts = new Date().getTime()
        for (var prop in params) {
            if(params[prop] === ''){
                continue;
            }
            args.push(`${encodeURIComponent(prop)}=${encodeURIComponent(params[prop])}`)
        }
        args.push("accessToken="+context.$store.getters.getUser.accessToken);
        args.push("userId="+context.$store.getters.getUser.userId);
        args.push("ts="+ts); //加入时间搓
        let argsSort = args.sort(function(s, t) {
            let a = s.toLowerCase();
            let b = t.toLowerCase();
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
        })
        API= `${basePath}${url}?${argsSort.join('&')}`
        var ssig = generateSigNew(argsSort.join('&'),ts)
        API+='&ssig='+ssig;
    }
    return API;
}

export function openLogin({context,basePath = rootPath, url, params = {},onCallBack,onErr}) {
    var API = ""
    if (params == "" || params == null) {
        API = `${basePath}${url}`
    } else {
        var args = []
        var ts = new Date().getTime()
        for (var prop in params) {
            if(params[prop] === ''){
                continue;
            }
            args.push(`${encodeURIComponent(prop)}=${encodeURIComponent(params[prop])}`)
        }
    /*    args.push("ts="+ts); //加入时间搓*/
        let argsSort = args.sort(function(s, t) {
            let a = s.toLowerCase();
            let b = t.toLowerCase();
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
        })
        API= `${basePath}${url}?${argsSort.join('&')}`
       /* var ssig = md5(argsSort.join('&')+'&'+'492vjvhbrgkcg8r5');
        API+='&sign='+ssig;*/
    }
    context.$http.get(API).then(function (res) {
        var body = res.body;
        if (body.flag === 1) {
            onCallBack(body.retinfo);
        }else{
            if('msg' in body && body.msg != undefined){
                context.$Message.error(body.msg);
            }else{
                onErr(body)
            }
        }
    }, function () {
        /*   context.$Message.error('Network request error!');*/
    }).catch(function (e) {
        console.log(e);
    });

}


